import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { MpCommonService } from "../../../services/api/mp-common.service";
import { MpCommonActions } from "../../actions/mp-common.actions";
import { FailState } from "../../models/fail-state";
import { DistributionKeyState } from "../../models/mp-common/distribution-key-state";
import { AppState } from "../../reducers";
import { MpCommonSelectors } from "../../selectors/mp-common.selectors";

@Injectable()
export class DistributionKeyGetEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(MpCommonActions.distributionKey.get),
			withLatestFrom(this.store.select(MpCommonSelectors.distributionKey)),
			switchMap(([, state]) =>
				this.canUseStoreValue(state)
					? of(MpCommonActions.distributionKey.getSuccess(state))
					: of(MpCommonActions.distributionKey.getApi())
			)
		)
	);

	// @ts-ignore
	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(MpCommonActions.distributionKey.getApi),
			switchMap(() =>
				this.marketplaceService.distributionKey().pipe(
					map((distributionKey) =>
						MpCommonActions.distributionKey.getSuccess({
							distributionKey,
							loading: false
						})
					),
					catchError((error) =>
						of(MpCommonActions.distributionKey.getFail(new FailState(error)))
					)
				)
			)
		)
	);
	constructor(
		private actions: Actions,
		private marketplaceService: MpCommonService,
		private store: Store<AppState>
	) {}

	private canUseStoreValue(state: DistributionKeyState): boolean {
		return !_.has(state, "error") && !state.loading && state.distributionKey?.length > 0;
	}
}
